const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?/;
const DMY_DATE_RE = /^\d{2}\/\d{2}\/\d{4}$/;

export const dateReviver = <T>(key: string, value: T): Date | T => {
  if (typeof value === 'string') {
    if (ISO_DATE_RE.test(value)) {
      const d = new Date(value);
      if (!isNaN(d.getTime())) return d;
    }
    if (DMY_DATE_RE.test(value)) {
      const [day, month, year] = value.split('/');
      const d = new Date(+year, +month - 1, +day);
      if (!isNaN(d.getTime())) return d;
    }
  }
  if (typeof value === 'number') {
    const s = String(value);
    if (s.length === 10 || s.length === 13) {
      const ts = s.length === 13 ? value : (value as number) * 1000;
      const d = new Date(ts);
      if (!isNaN(d.getTime())) return d;
    }
  }
  return value;
};
